export function DailyChallengeBonusIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5304 3.91724C16.3367 3.91724 17.1424 4.10964 17.8819 4.49634C18.8887 5.02354 19.6255 5.70564 20.17 6.41138C20.7636 5.67602 21.575 4.96783 22.6876 4.45435C24.2835 3.71905 26.1191 3.85081 27.6036 4.80591C29.02 5.71977 29.827 7.21269 29.7091 8.70435C29.6251 9.77071 29.0886 10.7206 28.1984 11.4309H28.504C30.294 11.4311 31.8179 12.9575 32.1388 15.0559C32.7455 19.0322 33.354 25.7968 32.0958 32.8704C31.7352 34.8962 30.2199 36.3391 28.4816 36.3391H11.4855C9.74642 36.3391 8.23013 34.8962 7.87023 32.8704C6.61134 25.7968 7.21984 19.0321 7.82726 15.0549C8.14817 12.9574 9.67204 11.4311 11.462 11.4309H12.2862C11.2604 10.654 10.6724 9.58708 10.6417 8.40552C10.6039 6.91063 11.4878 5.45772 12.9532 4.61353C13.7561 4.14979 14.644 3.91729 15.5304 3.91724ZM15.4757 7.76099C14.8562 7.76106 14.3536 8.22331 14.3536 8.79321C14.3538 9.36297 14.8641 9.82448 15.9855 9.97192H17.2677C17.2668 9.95469 17.2334 9.37352 16.9181 8.79321C16.5976 8.20354 16.0952 7.76101 15.4757 7.76099ZM24.3048 7.76099C23.6853 7.761 23.1829 8.20353 22.8624 8.79321C22.5469 9.37389 22.5137 9.95438 22.5128 9.97192H23.795C24.9163 9.82445 25.4257 9.36293 25.4259 8.79321C25.4259 8.22337 24.9242 7.76116 24.3048 7.76099Z"
        fill="#D9D9D9"
      />
      <path
        d="M15.5304 3.91724C16.3367 3.91724 17.1424 4.10964 17.8819 4.49634C18.8887 5.02354 19.6255 5.70564 20.17 6.41138C20.7636 5.67602 21.575 4.96783 22.6876 4.45435C24.2835 3.71905 26.1191 3.85081 27.6036 4.80591C29.02 5.71977 29.827 7.21269 29.7091 8.70435C29.6251 9.77071 29.0886 10.7206 28.1984 11.4309H28.504C30.294 11.4311 31.8179 12.9575 32.1388 15.0559C32.7455 19.0322 33.354 25.7968 32.0958 32.8704C31.7352 34.8962 30.2199 36.3391 28.4816 36.3391H11.4855C9.74642 36.3391 8.23013 34.8962 7.87023 32.8704C6.61134 25.7968 7.21984 19.0321 7.82726 15.0549C8.14817 12.9574 9.67204 11.4311 11.462 11.4309H12.2862C11.2604 10.654 10.6724 9.58708 10.6417 8.40552C10.6039 6.91063 11.4878 5.45772 12.9532 4.61353C13.7561 4.14979 14.644 3.91729 15.5304 3.91724ZM15.4757 7.76099C14.8562 7.76106 14.3536 8.22331 14.3536 8.79321C14.3538 9.36297 14.8641 9.82448 15.9855 9.97192H17.2677C17.2668 9.95469 17.2334 9.37352 16.9181 8.79321C16.5976 8.20354 16.0952 7.76101 15.4757 7.76099ZM24.3048 7.76099C23.6853 7.761 23.1829 8.20353 22.8624 8.79321C22.5469 9.37389 22.5137 9.95438 22.5128 9.97192H23.795C24.9163 9.82445 25.4257 9.36293 25.4259 8.79321C25.4259 8.22337 24.9242 7.76116 24.3048 7.76099Z"
        fill="url(#paint0_linear_1001_11507)"
      />
      <path
        d="M13.7879 15.0364C12.4921 15.0364 11.3888 16.1225 11.1566 17.6146C10.7169 20.4434 10.2762 25.2546 11.1875 30.2857C11.448 31.7266 12.5456 32.7524 13.8044 32.7524H26.1069C27.3652 32.7524 28.4623 31.7266 28.7234 30.2857C29.6341 25.2546 29.1934 20.4434 28.7542 17.6152C28.5221 16.1225 27.4188 15.0364 26.1229 15.0364H13.7879Z"
        fill="#00AE00"
      />
      <path
        d="M13.7879 15.0364C12.4921 15.0364 11.3888 16.1225 11.1566 17.6146C10.7169 20.4434 10.2762 25.2546 11.1875 30.2857C11.448 31.7266 12.5456 32.7524 13.8044 32.7524H26.1069C27.3652 32.7524 28.4623 31.7266 28.7234 30.2857C29.6341 25.2546 29.1934 20.4434 28.7542 17.6152C28.5221 16.1225 27.4188 15.0364 26.1229 15.0364H13.7879Z"
        fill="url(#paint1_linear_1001_11507)"
      />
      <path
        d="M30.4758 11C31.599 11 32.6648 11.5768 33.3596 12.5825L33.373 12.6022C33.4007 12.6425 33.4284 12.6837 33.4561 12.7257L33.5157 12.8169C34.1269 13.7662 34.7349 15.101 34.9717 16.8547C35.1949 18.5062 34.0701 20 32.6034 20H7.39589C5.92926 20 4.80452 18.5062 5.0285 16.8547C5.27405 15.0308 5.92168 13.6601 6.55771 12.7048L6.5738 12.6806L6.58712 12.6609C6.60494 12.6345 6.62273 12.6083 6.6405 12.5825C7.33452 11.5768 8.4004 11 9.52358 11H30.4758Z"
        fill="#D9D9D9"
      />
      <path
        d="M30.4758 11C31.599 11 32.6648 11.5768 33.3596 12.5825L33.373 12.6022C33.4007 12.6425 33.4284 12.6837 33.4561 12.7257L33.5157 12.8169C34.1269 13.7662 34.7349 15.101 34.9717 16.8547C35.1949 18.5062 34.0701 20 32.6034 20H7.39589C5.92926 20 4.80452 18.5062 5.0285 16.8547C5.27405 15.0308 5.92168 13.6601 6.55771 12.7048L6.5738 12.6806L6.58712 12.6609C6.60494 12.6345 6.62273 12.6083 6.6405 12.5825C7.33452 11.5768 8.4004 11 9.52358 11H30.4758Z"
        fill="url(#paint2_linear_1001_11507)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.3482 12.9797C34.3733 13.0119 34.3985 13.0447 34.4237 13.0779L34.4199 13.0729C34.396 13.0414 34.3721 13.0103 34.3482 12.9797ZM5.41669 13.0769C5.41669 13.0769 5.4167 13.0769 5.41669 13.0769V13.0769Z"
        fill="url(#paint3_linear_1001_11507)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.43403 13.0543L5.44839 13.0355C5.4378 13.0493 5.42721 13.0632 5.41663 13.0771L5.43403 13.0543Z"
        fill="url(#paint4_linear_1001_11507)"
      />
      <path
        d="M19.3758 22.687C19.5902 22.1075 20.4098 22.1075 20.6242 22.687L21.2442 24.3625C21.3117 24.5447 21.4553 24.6883 21.6375 24.7558L23.313 25.3758C23.8925 25.5902 23.8925 26.4098 23.313 26.6242L21.6375 27.2442C21.4553 27.3117 21.3117 27.4553 21.2442 27.6375L20.6242 29.313C20.4098 29.8925 19.5902 29.8925 19.3758 29.313L18.7558 27.6375C18.6883 27.4553 18.5447 27.3117 18.3625 27.2442L16.687 26.6242C16.1075 26.4098 16.1075 25.5902 16.687 25.3758L18.3625 24.7558C18.5447 24.6883 18.6883 24.5447 18.7558 24.3625L19.3758 22.687Z"
        fill="white"
      />
      <path
        d="M18.9619 22.5342C19.3185 21.5705 20.6815 21.5705 21.0381 22.5342L21.6582 24.209C21.6809 24.2704 21.7296 24.3191 21.791 24.3418L23.4658 24.9619C24.4295 25.3185 24.4295 26.6815 23.4658 27.0381L21.791 27.6582C21.7296 27.6809 21.6809 27.7296 21.6582 27.791L21.0381 29.4658C20.6815 30.4295 19.3185 30.4295 18.9619 29.4658L18.3418 27.791C18.3191 27.7296 18.2704 27.6809 18.209 27.6582L16.5342 27.0381C15.5705 26.6815 15.5705 25.3185 16.5342 24.9619L18.209 24.3418C18.2704 24.3191 18.3191 24.2704 18.3418 24.209L18.9619 22.5342Z"
        stroke="url(#paint5_linear_1001_11507)"
        strokeOpacity="0.48"
        strokeWidth="0.882622"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1001_11507"
          x1="26.6433"
          y1="3.9317"
          x2="26.6433"
          y2="10.6563"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2FD0F" />
          <stop offset="1" stopColor="#4CFD11" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1001_11507"
          x1="10.4639"
          y1="8.24395"
          x2="21.9614"
          y2="32.7092"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007900" />
          <stop offset="1" stopColor="#00C800" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1001_11507"
          x1="27.7758"
          y1="11.026"
          x2="27.7758"
          y2="22.8509"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2FD0F" />
          <stop offset="1" stopColor="#4CFD11" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1001_11507"
          x1="27.0195"
          y1="9.98101"
          x2="33.1208"
          y2="25.5116"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EECF78" />
          <stop offset="0.815806" stopColor="#FF8383" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1001_11507"
          x1="34.502"
          y1="12.3232"
          x2="5.41663"
          y2="12.3232"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8D041" />
          <stop offset="1" stopColor="#FFFFB9" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1001_11507"
          x1="15.0001"
          y1="25.9932"
          x2="25.0057"
          y2="25.9932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8FFB3" />
          <stop offset="1" stopColor="#F0FEB7" />
        </linearGradient>
      </defs>
    </svg>
  )
}
